var map = {
	"./de/go-to-details.png": "VUtp",
	"./en/go-to-details.png": "4bhG",
	"./es/go-to-details.png": "s/p3",
	"./fr/go-to-details.png": "1bXu",
	"./ja/go-to-details.png": "vlzT",
	"./ko/go-to-details.png": "i8JN",
	"./pt/go-to-details.png": "evwN",
	"./ru/go-to-details.png": "I6Mg",
	"./tc/go-to-details.png": "okpV",
	"./th/go-to-details.png": "70gX"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "IAe9";